/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Bar.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-bar");
exports.Bar = function Bar(_a) {
    var children = _a.children;
    return React.createElement("div", { className: moduleClassName() }, children);
};
exports.BarItem = function BarItem(_a) {
    var stretchy = _a.stretchy, fullyCentered = _a.fullyCentered, pushRight = _a.pushRight, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("item"), stretchy && moduleClassName("isStretchy"), fullyCentered && moduleClassName("isFullyCentered"), pushRight && moduleClassName("pushRight"), className) }, children));
};
exports.BarItem.propTypes = {
    stretchy: PropTypes.bool,
    fullyCentered: PropTypes.bool,
    pushRight: PropTypes.bool,
    className: PropTypes.string
};